import { useEffect, useState, useRef, useCallback } from "react"; // Tambahkan useCallback di sini
import {
    FaArrowLeft, 
    FaBath,
    FaBed,
    FaChevronLeft,
    FaChevronRight,
    FaClock,
    FaEnvelope,
    FaFacebookF,
    FaInstagram,
    FaMapMarkerAlt,
    FaMountain,
    FaPhone,
    FaStar,
    FaUsers
} from "react-icons/fa";
import { Link, useNavigate, useParams } from "react-router-dom";
import API_BASE_URL from "../config";
import "./css/VillaDetail.css";

function VillaDetail() {
    const { id } = useParams();
    const navigate = useNavigate();
    const sliderRef = useRef(null);

    const [villa, setVilla] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [current, setCurrent] = useState(0);

    const [checkIn, setCheckIn] = useState(null);
    const [checkOut, setCheckOut] = useState(null);
    const [activeTab, setActiveTab] = useState("fasilitas");
    const [showAllFacilities, setShowAllFacilities] = useState(false);

    // STATE UNTUK WISATA LAINNYA
    const [showAllNearby, setShowAllNearby] = useState(false);

    // STATE UNTUK MENGENDALIKAN KAMAR YANG DIPILIH
    const [selectedRoom, setSelectedRoom] = useState(null);

    // Fungsi dimodifikasi menggunakan useCallback & menggunakan metode GET agar tidak diblokir server lokal
    const loadRoomImages = useCallback(async (roomId, maxImages = 15) => {
        const validImages = [];
        for (let num = 1; num <= maxImages; num++) {
            const imgPath = `/images/villas/villa_${id}/rooms/room_${roomId}_${num}.png`;
            try {
                // Diubah menjadi GET karena HEAD sering kali mengembalikan status 404/405 di server lokal
                const res = await fetch(imgPath, { method: "GET" });
                if (res.ok) {
                    validImages.push(imgPath);
                } else {
                    break; 
                }
            } catch (error) {
                break;
            }
        }
        if (validImages.length === 0) {
            validImages.push("https://images.unsplash.com/photo-1572120360610-d971b9d7767c");
        }
        return validImages;
    }, [id]);

    // STATE BULAN DAN TAHUN UNTUK KALENDER
    const currentYear = new Date().getFullYear();
    const [currentMonth, setCurrentMonth] = useState(new Date().getMonth()); // 0-11
    const [chosenYear, setChosenYear] = useState(currentYear);

    const monthNames = [
        "Januari", "Februari", "Maret", "April", "Mei", "Juni",
        "Juli", "Agustus", "September", "Oktober", "November", "Desember"
    ];

    // Mengenerate jumlah hari berdasarkan bulan dan tahun terpilih
    const daysInMonth = new Date(chosenYear, currentMonth + 1, 0).getDate();
    const days = Array.from({ length: daysInMonth }, (_, i) => i + 1);

    // LIST WISATA JOGJA
    const nearbyAttractions = [
        { name: "Maha Sky Batu Angkruk", dist: "± 3 min (1,0 km)" },
        { name: "Wisata bukit awan sikapuk", dist: "± 3 min (1,2 km)" },
        { name: "HeHa Sky View", dist: "± 10 min (4,5 km)" },
        { name: "Candi Prambanan", dist: "± 20 min (12 km)" },
        { name: "Malioboro", dist: "± 15 min (8 km)" },
        { name: "Taman Sari", dist: "± 18 min (9,5 km)" },
        { name: "Keraton Yogyakarta", dist: "± 17 min (9 km)" },
        { name: "Pantai Parangtritis", dist: "± 45 min (28 km)" },
        { name: "Tebing Breksi", dist: "± 25 min (15 km)" },
        { name: "Gua Pindul", dist: "± 60 min (40 km)" }
    ];

    const customFacilities = [
        "2 kamar", "TV", "Free WIFI", "Teh, gula, kopi, Air mineral Galon",
        "Private pool", "Free breakfast untuk 5 orang",
        "Dapur lengkap peralatan masak,kompor, gas ,air galon, rice cooker,piring,gelas,penggorengan dll",
        "2 kamar mandi atas bawah", "Water heater", "Best view", "Amenities",
        "Parkir langsung belakang villa", "Kulkas"
    ];

    useEffect(() => {
        fetch(`${API_BASE_URL}/api/villas/${id}`)
            .then(res => {
                if (!res.ok) {
                    throw new Error("Villa tidak ditemukan di database");
                }
                return res.json();
            })
            .then(async (data) => { // Ditambahkan async di sini
                const facilitiesList = data.facilities ? data.facilities.split(',') : [];
                const otherFacilitiesList = data.other_facilities ? data.other_facilities.split(',') : [];

                const initialRoom = data.rooms && data.rooms.length > 0 ? data.rooms[0] : null;

                const defaultImages = [
                    `/images/villas/villa_${data.id || id}/utama.png`,
                    "https://images.unsplash.com/photo-1572120360610-d971b9d7767c"
                ];

                let mappedVilla = {
                    ...data,
                    img: data.img || `/images/villas/villa_${data.id || id}/utama.png`,
                    images: defaultImages,
                    facilitiesList: facilitiesList,
                    otherFacilitiesArray: otherFacilitiesList
                };

                // --- Simpan ke Recently Viewed ---
                try {
                    const savedHistory = localStorage.getItem("recentlyViewedVillas");
                    let history = savedHistory ? JSON.parse(savedHistory) : [];

                    history = history.filter(v => v.id !== mappedVilla.id);

                    const villaToSave = {
                        id: mappedVilla.id,
                        name: mappedVilla.name,
                        guests: mappedVilla.guests || 10,
                        price: mappedVilla.price,
                        viewedAt: new Date().getTime(),
                        img: `/images/villas/villa_${mappedVilla.id}/utama.png`
                    };

                    history.unshift(villaToSave);
                    if (history.length > 3) {
                        history = history.slice(0, 3);
                    }
                    localStorage.setItem("recentlyViewedVillas", JSON.stringify(history));
                } catch (e) {
                    console.error("Gagal menyimpan history:", e);
                }
                // ---------------------------------

                if (initialRoom) {
                    setSelectedRoom(initialRoom);
                    // Gunakan await agar setLoading tidak jalan mendahului proses pencarian foto
                    const imgs = await loadRoomImages(initialRoom.id_detail);
                    mappedVilla.images = imgs;
                }

                setVilla(mappedVilla);
                setLoading(false);
            })
            .catch(err => {
                console.error("Gagal memuat data detail:", err);
                setError(err.message);
                setLoading(false);
            });
    }, [id, loadRoomImages]); // Masukkan loadRoomImages ke dalam array dependensi

    const handleRoomSelect = async (room) => {
        setSelectedRoom(room);
        setCurrent(0); 

        const newRoomImages = await loadRoomImages(room.id_detail);
        setVilla(prev => ({
            ...prev,
            images: newRoomImages
        }));
    };

    const handleDateClick = (day) => {
        const rawDate = new Date(chosenYear, currentMonth, day);
        
        const isoString = rawDate.getFullYear() + "-" + 
                          String(rawDate.getMonth() + 1).padStart(2, '0') + "-" + 
                          String(rawDate.getDate()).padStart(2, '0');

        const selectedFormattedDate = {
            day,
            month: currentMonth,
            year: chosenYear,
            displayString: `${day} ${monthNames[currentMonth]} ${chosenYear}`,
            rawDate: rawDate, 
            isoString: isoString,
            timeValue: rawDate.getTime()
        };

        if (!checkIn) {
            setCheckIn(selectedFormattedDate);
        } else if (!checkOut) {
            if (selectedFormattedDate.timeValue > checkIn.timeValue) {
                setCheckOut(selectedFormattedDate);
            } else {
                setCheckIn(selectedFormattedDate);
                setCheckOut(null);
            }
        } else {
            setCheckIn(selectedFormattedDate);
            setCheckOut(null);
        }
    };

    const getDayClassName = (day) => {
        if (!checkIn) return "";
        const thisTime = new Date(chosenYear, currentMonth, day).getTime();

        if (checkIn && thisTime === checkIn.timeValue) return "checkin";
        if (checkOut && thisTime === checkOut.timeValue) return "checkout";
        if (checkIn && checkOut && thisTime > checkIn.timeValue && thisTime < checkOut.timeValue) return "range";

        return "";
    };

    const nextImage = () => {
        if (sliderRef.current) {
            sliderRef.current.scrollBy({ left: window.innerWidth * 0.5, behavior: "smooth" });
        }
    };

    const prevImage = () => {
        if (sliderRef.current) {
            sliderRef.current.scrollBy({ left: -(window.innerWidth * 0.5), behavior: "smooth" });
        }
    };

    if (loading) {
        return (
            <div style={{ textAlign: "center", padding: "100px 0", fontSize: "1.2rem" }}>
                Memuat detail villa...
            </div>
        );
    }

    if (error || !villa) {
        return (
            <div style={{ textAlign: "center", padding: "100px 0", color: "#d9534f" }}>
                <h2>{error || "Villa tidak ditemukan"}</h2>
                <button
                    onClick={() => navigate(-1)}
                    style={{ marginTop: "20px", padding: "10px 20px", cursor: "pointer" }}
                >
                    Kembali
                </button>
            </div>
        );
    }

    const currentPrice = selectedRoom && selectedRoom.price_raw && selectedRoom.price_raw > 0
        ? selectedRoom.price_raw
        : (villa.price || 0);

    return (
        <div className="villa-detail-page">
            {/* NAVBAR UTAMA */}
            <nav className="navbar" style={{ position: "relative" }}>
                <div className="logo">
                    <div className="logo-icon">
                        <FaMountain />
                    </div>
                    <div className="logo-text">
                        <h3>Permata Wisata</h3>
                        <span>Wisata Jogja</span>
                    </div>
                </div>
                <div className="nav-menu">
                    <Link to="/">Beranda</Link>
                    <Link to="/villas">Villa</Link>
                    <a
                        href="https://wa.me/081216687367?text=Halo%20admin%20Permata%20Wisata,%20saya%20ingin%20bertanya%20tentang%20villa"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="contact-btn"
                    >
                        Hubungi Kami
                    </a>
                </div>
            </nav>

            {/* HEADER ATAS */}
            <div className="detail-header-top" style={{ padding: "35px 80px 20px 80px", maxWidth: "1200px", margin: "auto" }}>
                <button
                    onClick={() => navigate("/villas")}
                    style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "8px",
                        backgroundColor: "#fff",
                        border: "1px solid #ddd",
                        color: "#555",
                        cursor: "pointer",
                        fontSize: "0.85rem",
                        fontWeight: "600",
                        padding: "8px 16px",
                        borderRadius: "20px",
                        marginBottom: "20px",
                        boxShadow: "0 2px 5px rgba(0,0,0,0.05)",
                        transition: "all 0.2s"
                    }}
                >
                    <FaArrowLeft /> Kembali ke Daftar
                </button>

                <h1 style={{ margin: "0 0 10px 0", fontSize: "2.2rem", color: "#1a1a1a" }}>{villa.name}</h1>
                
                <div style={{ display: "flex", alignItems: "center", gap: "15px", color: "#555", fontSize: "0.95rem" }}>
                    <span style={{ display: "flex", alignItems: "center", gap: "5px", color: "#facc15", fontWeight: "600" }}>
                        <FaStar /> {villa.rating || "5.0"} <span style={{ color: "#777", fontWeight: "normal", textDecoration: "underline", marginLeft: "2px" }}>(78 ulasan)</span>
                    </span>
                    <span style={{ color: "#ccc" }}>•</span>
                    <span style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                        <FaMapMarkerAlt style={{ color: "#0d6efd" }} /> {villa.location}
                    </span>
                </div>
            </div>

            {/* HERO BANNER SLIDER */}
            <div className="slider-wrapper" style={{ position: "relative", width: "100%", maxWidth: "1200px", margin: "0 auto", padding: "0 80px", backgroundColor: "transparent", borderBottom: "1px solid #eaeaea", boxSizing: "border-box" }}>
                <button className="slider-btn left" onClick={prevImage} style={{ zIndex: 10 }}>
                    <FaChevronLeft />
                </button>

                <div className="slider-track" ref={sliderRef}>
                    {villa.images && villa.images.map((imgUrl, index) => (
                        <img
                            key={index}
                            src={imgUrl}
                            alt={`${villa.name} - Foto ${index + 1}`}
                            className="slider-item-img"
                            onError={(e) => { e.target.style.display = 'none'; }}
                        />
                    ))}
                </div>

                <button className="slider-btn right" onClick={nextImage} style={{ zIndex: 10 }}>
                    <FaChevronRight />
                </button>
            </div>

            <div className="detail-container">
                <div className="detail-left">
                    <div className="detail-spec">
                        <span><FaUsers /> {selectedRoom ? selectedRoom.max_guests : (villa.guests || 10)} Tamu</span>
                        <span><FaBed /> {villa.beds || 5} Tempat Tidur</span>
                        <span><FaBath /> {villa.baths || 4} Kamar Mandi</span>
                    </div>

                    {/* PILIHAN TIPE KAMAR */}
                    <div className="detail-card" style={{ border: "2px solid #0d6efd", borderRadius: "10px", padding: "20px" }}>
                        <h3 style={{ color: "#0d6efd", marginBottom: "5px" }}>Pilih Variasi Tipe Kamar</h3>
                        <p style={{ color: "#777", fontSize: "0.85rem", marginBottom: "15px" }}>Silakan klik salah satu tipe kamar di bawah ini untuk melihat detail spesifik dan harga check-out:</p>

                        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                            {villa.rooms && villa.rooms.length > 0 ? (
                                villa.rooms.map((room, idx) => {
                                    const isSelected = selectedRoom?.id_detail === room.id_detail;
                                    return (
                                        <div
                                            key={idx}
                                            onClick={() => handleRoomSelect(room)}
                                            style={{
                                                padding: "15px",
                                                border: isSelected ? "2px solid #0d6efd" : "1px solid #ddd",
                                                backgroundColor: isSelected ? "#f0f7ff" : "#fff",
                                                borderRadius: "8px",
                                                cursor: "pointer",
                                                transition: "0.2s",
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center"
                                            }}
                                        >
                                            <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
                                                <img
                                                    src={`/images/villas/villa_${id}/rooms/room_${room.id_detail}_1.png`}
                                                    alt={room.bed_info}
                                                    style={{ width: "70px", height: "50px", objectFit: "cover", borderRadius: "4px" }}
                                                    onError={(e) => { e.target.src = "https://images.unsplash.com/photo-1590490360182-c33d57733427"; }}
                                                />
                                                <div>
                                                    <h4 style={{ margin: "0 0 5px 0", color: isSelected ? "#0d6efd" : "#333" }}>
                                                        {room.bed_info} {isSelected && " 🌟 (Dipilih)"}
                                                    </h4>
                                                    <p style={{ margin: 0, fontSize: "0.85rem", color: "#666" }}>
                                                        Fasilitas: {room.facilities.length > 60 ? `${room.facilities.slice(0, 60)}...` : room.facilities}
                                                    </p>
                                                </div>
                                            </div>
                                            <div style={{ textAlign: "right" }}>
                                                <span style={{ fontWeight: "bold", color: "#2ece7a", fontSize: "1.05rem" }}>
                                                    {room.price_raw && room.price_raw > 0 ? `Rp ${Number(room.price_raw).toLocaleString()}` : "Hubungi CS"}
                                                </span>
                                                <p style={{ margin: "2px 0 0 0", fontSize: "0.75rem", color: "#999" }}>/malam</p>
                                            </div>
                                        </div>
                                    );
                                })
                            ) : (
                                <p style={{ fontSize: "0.9rem", color: "#999" }}>Tidak ada variasi kamar tambahan untuk properti ini.</p>
                            )}
                        </div>
                    </div>

                    {/* KAPASITAS DAN UKURAN KASUR */}
                    <div className="detail-card">
                        <h3>Kapasitas & Aturan Kamar Terpilih</h3>
                        <p><strong>Maksimal Orang:</strong> {selectedRoom ? selectedRoom.max_guests : villa.max_guests} orang</p>
                        <p style={{ fontSize: "0.9rem", color: "#666", marginBottom: "15px" }}>
                            {selectedRoom ? selectedRoom.max_age_rule : villa.max_age_rule}
                        </p>
                        
                        <h4 style={{ marginBottom: "10px", color: "#444" }}>Ukuran bed:</h4>
                        <div style={{ display: "flex", alignItems: "center", gap: "12px", color: "#2c3e50", fontSize: "1.05rem", paddingLeft: "2px" }}>
                            <FaBed style={{ fontSize: "1.4rem", color: "#1e293b" }} />
                            <span style={{ fontWeight: "500" }}>
                                {selectedRoom ? (
                                    selectedRoom.bed_info
                                ) : villa.bed_info ? (
                                    villa.bed_info
                                ) : (
                                    "Queen: 160 x 200 cm — 3 buah"
                                )}
                            </span>
                        </div>
                    </div>

                    <div className="detail-card">
                        <h3>Tentang Villa Ini</h3>
                        <p>{villa.description || "Nikmati pengalaman menginap yang nyaman di villa indah yang terletak di Yogyakarta."}</p>
                    </div>

                    <div className="detail-card">
                        <div style={{ display: "flex", gap: "24px", borderBottom: "1px solid #eaeaea", paddingBottom: "10px", marginBottom: "20px" }}>
                            <h3
                                onClick={() => setActiveTab("fasilitas")}
                                style={{
                                    cursor: "pointer",
                                    color: activeTab === "fasilitas" ? "#0d6efd" : "#555",
                                    borderBottom: activeTab === "fasilitas" ? "2px solid #0d6efd" : "none",
                                    paddingBottom: "8px", margin: 0, fontSize: "1.2rem"
                                }}
                            >
                                Fasilitas
                            </h3>
                            <h3
                                onClick={() => setActiveTab("sk")}
                                style={{
                                    cursor: "pointer",
                                    color: activeTab === "sk" ? "#0d6efd" : "#555",
                                    borderBottom: activeTab === "sk" ? "2px solid #0d6efd" : "none",
                                    paddingBottom: "8px", margin: 0, fontSize: "1.2rem"
                                }}
                            >
                                S & K
                            </h3>
                        </div>

                        {activeTab === "fasilitas" && (
                            <div className="facilities">
                                {selectedRoom && (
                                    <div style={{ padding: "10px", backgroundColor: "#f9f9f9", borderRadius: "6px", marginBottom: "15px", borderLeft: "4px solid #f89406" }}>
                                        <span style={{ fontSize: "0.85rem", fontWeight: "bold", color: "#444" }}>Fasilitas CSV ({selectedRoom.bed_info}):</span>
                                        <p style={{ margin: "5px 0 0 0", fontSize: "0.9rem", color: "#555" }}>{selectedRoom.facilities}</p>
                                        <p style={{ margin: "3px 0 0 0", fontSize: "0.85rem", color: "#888", fontStyle: "italic" }}>{selectedRoom.other_facilities}</p>
                                    </div>
                                )}

                                {(showAllFacilities ? customFacilities : customFacilities.slice(0, 5)).map((fac, idx) => (
                                    <div key={idx} style={{ display: "flex", alignItems: "center", marginBottom: "12px" }}>
                                        <span style={{ color: "#f89406", marginRight: "8px" }}>◎</span>
                                        {fac}
                                    </div>
                                ))}
                                {customFacilities.length > 5 && (
                                    <div style={{ marginTop: "16px" }}>
                                        <span
                                            onClick={() => setShowAllFacilities(!showAllFacilities)}
                                            style={{ color: "#0d6efd", textDecoration: "underline", cursor: "pointer", fontWeight: 500 }}
                                        >
                                            {showAllFacilities ? "Sembunyikan Fasilitas" : "Lihat Fasilitas lainnya"}
                                        </span>
                                    </div>
                                )}
                            </div>
                        )}

                        {activeTab === "sk" && (
                            <div className="rules" style={{ color: "#555" }}>
                                <p style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "10px" }}>
                                    <FaClock /> Check-in: 14:00
                                </p>
                                <p style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "10px" }}>
                                    <FaClock /> Check-out: 12:00
                                </p>
                                <p style={{ marginBottom: "10px" }}>🚭 Dilarang merokok di dalam</p>
                                <p style={{ marginBottom: "10px" }}>🐾 Tidak diperbolehkan membawa hewan</p>
                            </div>
                        )}
                    </div>

                    <div className="detail-card">
                        <h3>Wisata Terdekat</h3>
                        <div style={{ display: "flex", flexWrap: "wrap", gap: "15px", marginTop: "15px", fontSize: "0.95rem", color: "#333" }}>
                            {(showAllNearby ? nearbyAttractions : nearbyAttractions.slice(0, 2)).map((place, idx) => (
                                <div key={idx} style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                    <FaMapMarkerAlt style={{ color: "#888", fontSize: "0.85rem" }} />
                                    <span><strong>{place.name}</strong> {place.dist}</span>
                                </div>
                            ))}
                        </div>
                        <div style={{ marginTop: "12px" }}>
                            <span
                                onClick={() => setShowAllNearby(!showAllNearby)}
                                style={{ color: "#0d6efd", cursor: "pointer", fontSize: "0.9rem" }}
                            >
                                {showAllNearby ? "Sembunyikan" : "Lihat Jarak ke Wisata lainnya"}
                            </span>
                        </div>
                    </div>

                    <div className="detail-card">
                        <h3>Lokasi</h3>
                        <div className="map">
                            <iframe
                                title="villa-location"
                                src={`https://maps.google.com/maps?q=${encodeURIComponent(villa.location || 'Yogyakarta')}&output=embed`}
                                width="100%"
                                height="300"
                                style={{ border: 0 }}
                                loading="lazy"
                            />
                        </div>
                    </div>
                </div>

                {/* BOOKING BOX KANAN */}
                <div className="booking-box">
                    <p className="start-text">Harga Kamar Dipilih</p>
                    <h2>
                        Rp {Number(currentPrice).toLocaleString()}
                        <span>/malam</span>
                    </h2>

                    {selectedRoom && (
                        <p style={{ fontSize: "0.85rem", color: "#0d6efd", marginTop: "-5px", marginBottom: "15px", fontWeight: "500" }}>
                            Room: {selectedRoom.bed_info}
                        </p>
                    )}

                    <div className="calendar-box">
                        <h4>Pilih Tanggal Booking</h4>

                        <div style={{ display: "flex", gap: "8px", marginBottom: "12px" }}>
                            <select
                                value={currentMonth}
                                onChange={(e) => {
                                    setCurrentMonth(Number(e.target.value));
                                    setCheckIn(null); 
                                    setCheckOut(null);
                                }}
                                style={{ flex: 1, padding: "6px", borderRadius: "4px", border: "1px solid #ccc", fontSize: "0.85rem" }}
                            >
                                {monthNames.map((m, idx) => (
                                    <option key={idx} value={idx}>{m}</option>
                                ))}
                            </select>

                            <select
                                value={chosenYear}
                                onChange={(e) => {
                                    setChosenYear(Number(e.target.value));
                                    setCheckIn(null);
                                    setCheckOut(null);
                                }}
                                style={{ padding: "6px", borderRadius: "4px", border: "1px solid #ccc", fontSize: "0.85rem" }}
                            >
                                <option value={currentYear}>{currentYear}</option>
                                <option value={currentYear + 1}>{currentYear + 1}</option>
                            </select>
                        </div>

                        <div className="calendar-grid" style={{ fontSize: "0.85rem", gap: "4px" }}>
                            {days.map((day) => (
                                <div
                                    key={day}
                                    className={`day ${getDayClassName(day)}`}
                                    onClick={() => handleDateClick(day)}
                                    style={{ padding: "6px 0", fontSize: "0.85rem", borderRadius: "4px" }}
                                >
                                    {day}
                                </div>
                            ))}
                        </div>

                        <div className="selected-date" style={{ fontSize: "0.85rem", marginTop: "12px" }}>
                            <p>Check-in: {checkIn ? checkIn.displayString : "-"}</p>
                            <p>Check-out: {checkOut ? checkOut.displayString : "-"}</p>
                        </div>
                    </div>

                    <div className="booking-features">
                        <p>✔ Tanpa biaya pemesanan</p>
                        <p>✔ Pembatalan gratis</p>
                        <p>✔ Konfirmasi instan</p>
                        <p>✔ Pembayaran aman</p>
                    </div>

                    {/* ACTION PESAN SEKARANG */}
                    <button
                        className="book-now"
                        disabled={!checkIn || !checkOut}
                        onClick={() => {
                            const combinedRoomName = selectedRoom 
                                ? `${villa.name} - ${selectedRoom.bed_info}`
                                : villa.name;

                            const chosenRoomImage = selectedRoom 
                                ? `/images/villas/villa_${id}/rooms/room_${selectedRoom.id_detail}_1.png` 
                                : (villa.img || `/images/villas/villa_${id}/utama.png`);

                            navigate("/booking", {
                                state: {
                                    villa: {
                                        ...villa,
                                        id: villa.id || id,
                                        name: combinedRoomName,
                                        price: currentPrice,
                                        img: chosenRoomImage, 
                                        chosen_room_detail: selectedRoom,
                                    },
                                    room: selectedRoom,
                                    checkIn: checkIn?.displayString,        
                                    checkOut: checkOut?.displayString,      
                                    checkInRaw: checkIn?.rawDate,           
                                    checkOutRaw: checkOut?.rawDate,         
                                    checkInISO: checkIn?.isoString,         
                                }
                            });
                        }}
                    >
                        Pesan Sekarang
                    </button>
                </div>
            </div>
        </div>
    );
}

export default VillaDetail;